export enum PropertyPanelTabId
{
    Default = 'Default',
    Hover = 'Hover',
    Active = 'Active',
    Focus = 'Focus',
    Selected = 'Selected',
}
